import { Injectable } from '@angular/core';
import { Product } from '../interfaces/product';
import { Category } from '../interfaces/category';

@Injectable({
    providedIn: 'root'
})
export class RootService {
    constructor() { }

    home(): string {
        return '/';
    }

    shop(): string {
        return `/shop`;
    }

    wishlist(): string {
        return `/shop/wishlist`;
    }

    category(category: Partial<Category>): string {
        const basePath = this.shop();

            if ('slug' in category) {
                return `${basePath}/${category.slug}`;
            }

            throw Error('Provide category with "path", "slug" or "id".');
    }

    product(product: Partial<Product>): string {
        const basePath = '/';

        if ('slug' in product) {
            return `${basePath}/${product.slug}`;
        }

        throw Error('Provide product with "slug" or "id".');
    }

    brand(brand: any): string {
        return '/';
    }

    cart(): string {
        return '/shop/cart';
    }

    checkout(): string {
        return '/shop/cart/checkout';
    }

    login(): string {
        return '/auth';
    }

    terms(): string {
        return '/home/terms';
    }

    notFound(): string {
        return `/shop`;
    }
}
